/**
 * Invoice table column configuration for Analytics
 * Defines which columns support filtering and sorting
 */

/**
 * Columns that support filtering with metadata
 */
export const INVOICE_FILTER_COLUMNS = new Set([
  'invoiceNumber',
  'fapRef',
  'billedEntity',
  'invoiceStatus',
  'reason',
  'serviceProvider',
  'modality',
  'accountNumber',
  'shipmentNumber',
  'invoiceChargesCount',
]);

/**
 * Columns that support sorting only (no filter metadata)
 */
export const INVOICE_SORT_ONLY_COLUMNS = new Set(['date', 'totalAmount', 'totalAmountInReferenceCurrency', 'resolutionDate']);

/**
 * All sortable columns (filter + sort-only)
 */
export const INVOICE_SORTABLE_COLUMNS = new Set([...INVOICE_FILTER_COLUMNS, ...INVOICE_SORT_ONLY_COLUMNS]);

/**
 * Maps UI column accessorKeys to API column names
 * Used for fetching filter metadata
 */
export const INVOICE_COLUMN_NAME_MAP: Record<string, string> = {
  invoiceNumber: 'INVOICE_NUMBER',
  fapRef: 'FAP_REF',
  billedEntity: 'BILLED_ENTITY_NAME',
  invoiceStatus: 'INVOICE_STATUS',
  reason: 'INVOICE_REASON',
  serviceProvider: 'SERVICE_PROVIDER_NAME',
  modality: 'MODALITY',
  accountNumber: 'ACCOUNT_NUMBER',
  shipmentNumber: 'SHIPMENT_NUMBER',
  invoiceChargesCount: 'INVOICE_CHARGES_COUNT',
};
